module.exports = __webpack_public_path__ + "img/logo_game.90937ab2.png";